// Life is a Project — V3 copy (EN / ES / NL / FR)
// English is primary. Spanish, Dutch and French translations follow the
// same editorial register: contemporary, personal, intellectually serious.

export const t3 = {
    brand: {
        en: "Life is a Project",
        es: "Life is a Project",
        nl: "Life is a Project",
        fr: "Life is a Project",
    },
    tagline: {
        en: "A Brighter Tomorrow Through Vision, Ideas and Action.",
        es: "Un mañana más luminoso a través de la visión, las ideas y la acción.",
        nl: "Een helderder morgen door visie, ideeën en actie.",
        fr: "Un avenir plus clair par la vision, les idées et l’action.",
    },
    positioning: {
        en: "An independent platform for ideas, research and projects.",
        es: "Una plataforma independiente para ideas, investigación y proyectos.",
        nl: "Een onafhankelijk platform voor ideeën, onderzoek en projecten.",
        fr: "Une plateforme indépendante pour les idées, la recherche et les projets.",
    },

    /* ---------- Sidebar navigation ---------- */
    nav: {
        home:       { en: "Home",       es: "Inicio",       nl: "Home",         fr: "Accueil" },
        ideas:      { en: "Ideas",      es: "Ideas",        nl: "Ideeën",       fr: "Idées" },
        research:   { en: "Research",   es: "Investigación",nl: "Onderzoek",    fr: "Recherche" },
        projects:   { en: "Projects",   es: "Proyectos",    nl: "Projecten",    fr: "Projets" },
        memoire:    { en: "Memoire",    es: "Memoire",      nl: "Memoire",      fr: "Mémoire" },
        about:      { en: "About",      es: "Sobre",        nl: "Over",         fr: "À propos" },
        philosophy: { en: "Philosophy", es: "Filosofía",    nl: "Filosofie",    fr: "Philosophie" },
        lighthouse: { en: "The Lighthouse", es: "El Faro",  nl: "De Vuurtoren", fr: "Le Phare" },
        contact:    { en: "Contact",    es: "Contacto",     nl: "Contact",      fr: "Contact" },
        menu:       { en: "Menu",       es: "Menú",         nl: "Menu",         fr: "Menu" },
        close:      { en: "Close",      es: "Cerrar",       nl: "Sluiten",      fr: "Fermer" },
    },

    /* ---------- Home ---------- */
    home: {
        hero: {
            headline: {
                en: ["Life is a Project.", "Ideas become projects.", "Projects become experience."],
                es: ["Life is a Project.", "Las ideas se vuelven proyectos.", "Los proyectos se vuelven experiencia."],
                nl: ["Life is a Project.", "Ideeën worden projecten.", "Projecten worden ervaring."],
                fr: ["Life is a Project.", "Les idées deviennent projets.", "Les projets deviennent expérience."],
            },
            support: {
                en: "An independent platform for ideas, research and projects.",
                es: "Una plataforma independiente para ideas, investigación y proyectos.",
                nl: "Een onafhankelijk platform voor ideeën, onderzoek en projecten.",
                fr: "Une plateforme indépendante pour les idées, la recherche et les projets.",
            },
            ctaIdeas:    { en: "Explore Ideas",    es: "Explorar Ideas",    nl: "Ontdek Ideeën",   fr: "Explorer les Idées" },
            ctaResearch: { en: "Explore Research", es: "Explorar Investigación", nl: "Ontdek Onderzoek", fr: "Explorer la Recherche" },
            ctaProjects: { en: "Explore Projects", es: "Explorar Proyectos", nl: "Ontdek Projecten", fr: "Explorer les Projets" },
        },
        what: {
            title: {
                en: "What is Life is a Project?",
                es: "¿Qué es Life is a Project?",
                nl: "Wat is Life is a Project?",
                fr: "Qu’est-ce que Life is a Project ?",
            },
            body: {
                en: "Life is a Project is a space for exploring ideas, developing projects and documenting what is learned along the way.",
                es: "Life is a Project es un espacio para explorar ideas, desarrollar proyectos y documentar lo aprendido en el camino.",
                nl: "Life is a Project is een ruimte om ideeën te verkennen, projecten te ontwikkelen en te documenteren wat onderweg wordt geleerd.",
                fr: "Life is a Project est un espace pour explorer des idées, développer des projets et documenter ce qui est appris en chemin.",
            },
            areas: {
                en: [
                    { key: "ideas",      t: "Ideas",       d: "Exploring the questions that matter.", route: "/ideas" },
                    { key: "research",   t: "Research",    d: "Turning knowledge into insights.",     route: "/research" },
                    { key: "projects",   t: "Projects",    d: "Turning ideas into action.",           route: "/projects" },
                    { key: "philosophy", t: "Philosophy",  d: "The idea behind the project.",         route: "/philosophy" },
                ],
                es: [
                    { key: "ideas",      t: "Ideas",       d: "Explorar las preguntas que importan.", route: "/ideas" },
                    { key: "research",   t: "Investigación", d: "Convertir el conocimiento en criterio.", route: "/research" },
                    { key: "projects",   t: "Proyectos",   d: "Convertir las ideas en acción.",       route: "/projects" },
                    { key: "philosophy", t: "Filosofía",   d: "La idea detrás del proyecto.",         route: "/philosophy" },
                ],
                nl: [
                    { key: "ideas",      t: "Ideeën",      d: "De vragen verkennen die ertoe doen.", route: "/ideas" },
                    { key: "research",   t: "Onderzoek",   d: "Kennis omzetten in inzicht.",         route: "/research" },
                    { key: "projects",   t: "Projecten",   d: "Ideeën omzetten in actie.",           route: "/projects" },
                    { key: "philosophy", t: "Filosofie",   d: "Het idee achter het project.",        route: "/philosophy" },
                ],
                fr: [
                    { key: "ideas",      t: "Idées",       d: "Explorer les questions qui comptent.", route: "/ideas" },
                    { key: "research",   t: "Recherche",   d: "Transformer le savoir en discernement.", route: "/research" },
                    { key: "projects",   t: "Projets",     d: "Transformer les idées en action.",     route: "/projects" },
                    { key: "philosophy", t: "Philosophie", d: "L’idée derrière le projet.",           route: "/philosophy" },
                ],
            },
        },
        philosophy: {
            overline: {
                en: "The idea behind the project",
                es: "La idea detrás del proyecto",
                nl: "Het idee achter het project",
                fr: "L’idée derrière le projet",
            },
            line1: {
                en: "Life is a project in constant construction and evolution.",
                es: "La vida es un proyecto en construcción y evolución constantes.",
                nl: "Het leven is een project in voortdurende opbouw en evolutie.",
                fr: "La vie est un projet en construction et en évolution constantes.",
            },
            line2: {
                en: "Our work, experiences and sacrifices shape the way we build it. Our vision gives it direction. Our projects give that vision form.",
                es: "Nuestro trabajo, nuestras experiencias y nuestros sacrificios modelan la forma en que la construimos. La visión le da dirección. Los proyectos le dan forma.",
                nl: "Ons werk, onze ervaringen en onze offers vormen de manier waarop we het bouwen. Onze visie geeft het richting. Onze projecten geven die visie vorm.",
                fr: "Notre travail, nos expériences et nos sacrifices façonnent la manière dont nous le construisons. Notre vision lui donne une direction. Nos projets lui donnent forme.",
            },
            link: {
                en: "Explore the philosophy",
                es: "Explorar la filosofía",
                nl: "Ontdek de filosofie",
                fr: "Explorer la philosophie",
            },
        },
    },

    /* ---------- Ideas ---------- */
    ideas: {
        overline: {
            en: "Ideas",
            es: "Ideas",
            nl: "Ideeën",
            fr: "Idées",
        },
        title: {
            en: "Ideas",
            es: "Ideas",
            nl: "Ideeën",
            fr: "Idées",
        },
        lede: {
            en: "Questions, reflections and perspectives on the world around us.",
            es: "Preguntas, reflexiones y perspectivas sobre el mundo que nos rodea.",
            nl: "Vragen, reflecties en perspectieven op de wereld om ons heen.",
            fr: "Questions, réflexions et perspectives sur le monde qui nous entoure.",
        },
        body: {
            en: "This section will grow with essays, reflections, concepts and shorter articles — the intellectual notes of an evolving project.",
            es: "Esta sección crecerá con ensayos, reflexiones, conceptos y textos breves — los apuntes intelectuales de un proyecto en evolución.",
            nl: "Deze afdeling groeit met essays, reflecties, concepten en kortere artikelen — de intellectuele aantekeningen van een groeiend project.",
            fr: "Cette section grandira avec des essais, des réflexions, des concepts et des textes plus courts — les notes intellectuelles d’un projet en évolution.",
        },
        empty: {
            en: "Ideas are being developed.",
            es: "Se están desarrollando ideas.",
            nl: "Ideeën worden ontwikkeld.",
            fr: "Des idées sont en cours de développement.",
        },
        readOne: { en: "Read", es: "Leer", nl: "Lees", fr: "Lire" },
    },

    /* ---------- Memoire ---------- */
    memoire: {
        overline: {
            en: "Memoire",
            es: "Memoire",
            nl: "Memoire",
            fr: "Mémoire",
        },
        title: {
            en: "What I lived and learned.",
            es: "Lo que viví y aprendí.",
            nl: "Wat ik heb beleefd en geleerd.",
            fr: "Ce que j’ai vécu et appris.",
        },
        lede: {
            en: "Lived experiences, moments and decisions — reflected upon, and turned into lessons.",
            es: "Experiencias vividas, momentos y decisiones — reflexionados y convertidos en aprendizaje.",
            nl: "Beleefde ervaringen, momenten en beslissingen — beschouwd en omgezet in lessen.",
            fr: "Expériences vécues, moments et décisions — repensés et transformés en leçons.",
        },
        body: {
            en: "A personal editorial collection: experiences that became reflection, reflection that became lesson, and lesson that became growth. Written to be useful to others walking similar paths.",
            es: "Una colección editorial personal: experiencias que se volvieron reflexión, reflexión que se volvió aprendizaje, y aprendizaje que se volvió crecimiento. Escrita para ser útil a quienes recorren caminos parecidos.",
            nl: "Een persoonlijke redactionele verzameling: ervaringen die reflectie werden, reflectie die les werd, en les die groei werd. Geschreven om van nut te zijn voor anderen op een vergelijkbaar pad.",
            fr: "Une collection éditoriale personnelle : des expériences devenues réflexion, une réflexion devenue leçon, une leçon devenue croissance. Écrite pour être utile à ceux qui suivent des chemins semblables.",
        },
        empty: {
            en: "Memoire entries are being written.",
            es: "Las entradas de Memoire se están escribiendo.",
            nl: "Memoire-stukken worden geschreven.",
            fr: "Les textes Mémoire sont en cours d’écriture.",
        },
        readOne: { en: "Read", es: "Leer", nl: "Lees", fr: "Lire" },
    },

    /* ---------- Research ---------- */
    research: {
        overline: {
            en: "Research",
            es: "Investigación",
            nl: "Onderzoek",
            fr: "Recherche",
        },
        title: {
            en: "Research",
            es: "Investigación",
            nl: "Onderzoek",
            fr: "Recherche",
        },
        lede: {
            en: "Independent research, articles and investigations exploring society, international affairs, development, technology and the human experience.",
            es: "Investigación independiente, artículos e indagaciones sobre sociedad, asuntos internacionales, desarrollo, tecnología y experiencia humana.",
            nl: "Onafhankelijk onderzoek, artikelen en verkenningen over samenleving, internationale zaken, ontwikkeling, technologie en de menselijke ervaring.",
            fr: "Recherche indépendante, articles et enquêtes sur la société, les affaires internationales, le développement, la technologie et l’expérience humaine.",
        },
        categoriesHeading: {
            en: "Areas of enquiry",
            es: "Áreas de estudio",
            nl: "Onderzoeksgebieden",
            fr: "Domaines d’enquête",
        },
        categories: {
            en: ["Society", "International Affairs", "Development", "Technology", "Organisations", "Human Life"],
            es: ["Sociedad", "Asuntos Internacionales", "Desarrollo", "Tecnología", "Organizaciones", "Vida Humana"],
            nl: ["Samenleving", "Internationale Zaken", "Ontwikkeling", "Technologie", "Organisaties", "Menselijk Leven"],
            fr: ["Société", "Affaires Internationales", "Développement", "Technologie", "Organisations", "Vie Humaine"],
        },
        empty: {
            en: "Research is in preparation.",
            es: "La investigación está en preparación.",
            nl: "Onderzoek is in voorbereiding.",
            fr: "La recherche est en préparation.",
        },
    },

    /* ---------- Projects ---------- */
    projects: {
        overline: {
            en: "Projects",
            es: "Proyectos",
            nl: "Projecten",
            fr: "Projets",
        },
        title: {
            en: "Projects",
            es: "Proyectos",
            nl: "Projecten",
            fr: "Projets",
        },
        lede: {
            en: "Some ideas remain ideas. Others become projects.",
            es: "Algunas ideas siguen siendo ideas. Otras se convierten en proyectos.",
            nl: "Sommige ideeën blijven ideeën. Andere worden projecten.",
            fr: "Certaines idées restent des idées. D’autres deviennent des projets.",
        },
        body: {
            en: "This is where they will eventually be documented — with their questions, their process, and what they leave behind.",
            es: "Aquí se documentarán en su momento — con sus preguntas, su proceso y lo que dejen tras de sí.",
            nl: "Hier zullen ze uiteindelijk worden gedocumenteerd — met hun vragen, hun proces en wat ze achterlaten.",
            fr: "C’est ici qu’ils seront documentés en temps voulu — avec leurs questions, leur processus et ce qu’ils laissent.",
        },
        empty: {
            en: "Projects in preparation. The first public documentation will appear here when a project is ready to be shared.",
            es: "Proyectos en preparación. La primera documentación pública aparecerá aquí cuando un proyecto esté listo para compartirse.",
            nl: "Projecten in voorbereiding. De eerste publieke documentatie verschijnt hier zodra een project klaar is om te worden gedeeld.",
            fr: "Projets en préparation. La première documentation publique paraîtra ici lorsqu’un projet sera prêt à être partagé.",
        },
    },

    /* ---------- About ---------- */
    about: {
        overline: {
            en: "About",
            es: "Sobre",
            nl: "Over",
            fr: "À propos",
        },
        title: {
            en: "Where ideas meet experience.",
            es: "Donde las ideas se encuentran con la experiencia.",
            nl: "Waar ideeën en ervaring elkaar ontmoeten.",
            fr: "Là où les idées rencontrent l’expérience.",
        },
        body: {
            en: [
                "For years, my work has moved across academia, diplomacy, international cooperation and project development. These experiences may appear different, but they share a common question:",
                "How do ideas become action?",
                "Life is a Project grew from that intersection — where research meets practice, where experience shapes ideas, and where a vision begins to take form through projects.",
                "It is an independent platform for exploring ideas, developing projects, conducting research and documenting what is learned along the way.",
                "Not a résumé. Not an institution. A growing body of work.",
            ],
            es: [
                "Durante años, mi trabajo se ha movido entre la academia, la diplomacia, la cooperación internacional y el desarrollo de proyectos. Son experiencias distintas, pero comparten una misma pregunta:",
                "¿Cómo se convierten las ideas en acción?",
                "Life is a Project nació en ese cruce — donde la investigación encuentra la práctica, donde la experiencia da forma a las ideas y donde una visión empieza a tomar cuerpo a través de los proyectos.",
                "Es una plataforma independiente para explorar ideas, desarrollar proyectos, hacer investigación y documentar lo aprendido en el camino.",
                "No es un currículum. No es una institución. Es una obra en construcción.",
            ],
            nl: [
                "Jarenlang heeft mijn werk zich bewogen tussen academie, diplomatie, internationale samenwerking en projectontwikkeling. Deze ervaringen lijken verschillend, maar delen dezelfde vraag:",
                "Hoe worden ideeën actie?",
                "Life is a Project ontstond op dat kruispunt — waar onderzoek en praktijk elkaar raken, waar ervaring ideeën vormt, en waar een visie via projecten vorm krijgt.",
                "Het is een onafhankelijk platform om ideeën te verkennen, projecten te ontwikkelen, onderzoek te doen en te documenteren wat onderweg wordt geleerd.",
                "Geen cv. Geen instelling. Een groeiend oeuvre.",
            ],
            fr: [
                "Depuis des années, mon travail traverse l’université, la diplomatie, la coopération internationale et le développement de projets. Ces expériences paraissent différentes, mais elles partagent une même question :",
                "Comment les idées deviennent-elles action ?",
                "Life is a Project est né à cette intersection — là où la recherche rencontre la pratique, où l’expérience façonne les idées, et où une vision commence à prendre forme à travers des projets.",
                "C’est une plateforme indépendante pour explorer des idées, développer des projets, mener des recherches et documenter ce qui est appris en chemin.",
                "Ni un CV. Ni une institution. Une œuvre en construction.",
            ],
        },
        columns: {
            en: [
                { k: "Academic",  v: "International Relations · Research · Public Policy" },
                { k: "Practice",  v: "Diplomacy · Cooperation · Project Development" },
                { k: "Origin",    v: "Dominican Republic → International" },
            ],
            es: [
                { k: "Académico", v: "Relaciones Internacionales · Investigación · Política Pública" },
                { k: "Práctica",  v: "Diplomacia · Cooperación · Desarrollo de Proyectos" },
                { k: "Origen",    v: "República Dominicana → Internacional" },
            ],
            nl: [
                { k: "Academisch", v: "Internationale Betrekkingen · Onderzoek · Publiek Beleid" },
                { k: "Praktijk",   v: "Diplomatie · Samenwerking · Projectontwikkeling" },
                { k: "Herkomst",   v: "Dominicaanse Republiek → Internationaal" },
            ],
            fr: [
                { k: "Académique", v: "Relations Internationales · Recherche · Politique Publique" },
                { k: "Pratique",   v: "Diplomatie · Coopération · Développement de Projets" },
                { k: "Origine",    v: "République Dominicaine → International" },
            ],
        },
        personHeading: {
            en: "The person behind Life is a Project",
            es: "La persona detrás de Life is a Project",
            nl: "De persoon achter Life is a Project",
            fr: "La personne derrière Life is a Project",
        },
        pepeChapter: {
            en: "In continuity",
            es: "En continuidad",
            nl: "In continuïteit",
            fr: "En continuité",
        },
        pepeHeading: {
            en: "Nicomedes “Pepe” Castro Salas",
            es: "Nicomedes “Pepe” Castro Salas",
            nl: "Nicomedes “Pepe” Castro Salas",
            fr: "Nicomedes « Pepe » Castro Salas",
        },
        pepeLede: {
            en: "For decades he insisted, patiently, that everything that transforms a society begins with a project.",
            es: "Durante décadas insistió, con paciencia, en que todo lo que transforma una sociedad empieza por un proyecto.",
            nl: "Decennialang hield hij geduldig vol dat alles wat een samenleving verandert, begint met een project.",
            fr: "Pendant des décennies, il a soutenu, patiemment, que tout ce qui transforme une société commence par un projet.",
        },
        pepeQuote: {
            en: "Everything that truly transforms a society begins, quietly, with a project.",
            es: "Todo lo que realmente transforma una sociedad empieza, en silencio, por un proyecto.",
            nl: "Alles wat een samenleving werkelijk verandert, begint, in stilte, met een project.",
            fr: "Tout ce qui transforme véritablement une société commence, en silence, par un projet.",
        },
        pepeAttribution: {
            en: "— Nicomedes “Pepe” Castro Salas",
            es: "— Nicomedes “Pepe” Castro Salas",
            nl: "— Nicomedes “Pepe” Castro Salas",
            fr: "— Nicomedes « Pepe » Castro Salas",
        },
        pepeBody: {
            en: [
                "His life was devoted to community development, social initiatives and public service in the Dominican Republic. He preferred practical action to declarations, and the slow accumulation of small, deliberate improvements to the promises of large abstractions.",
                "He believed that a project only exists when it survives its encounter with reality — when the community lives it, adjusts it, and carries it forward. Every method he built, every lesson he taught, returned to this simple test.",
                "His philosophy evolved as the country did, but its centre never moved: a project is how a vision meets the ground.",
                "Life is a Project does not simply preserve that philosophy. It develops, expands and adapts it for a changing world — into new languages, new instruments, and new fields of practice.",
            ],
            es: [
                "Su vida se dedicó al desarrollo comunitario, a iniciativas sociales y al servicio público en la República Dominicana. Prefería la acción práctica a las declaraciones, y la acumulación lenta de mejoras pequeñas y deliberadas a las promesas de grandes abstracciones.",
                "Creía que un proyecto sólo existe cuando sobrevive a su encuentro con la realidad — cuando la comunidad lo vive, lo ajusta y lo lleva adelante. Cada método que construyó, cada lección que enseñó, volvía a esa prueba sencilla.",
                "Su filosofía evolucionó como evolucionó el país, pero su centro nunca se movió: un proyecto es la manera en que una visión toca el suelo.",
                "Life is a Project no se limita a preservar esa filosofía. La desarrolla, la amplía y la adapta para un mundo que cambia — a nuevos idiomas, a nuevos instrumentos, a nuevos campos de práctica.",
            ],
            nl: [
                "Zijn leven was gewijd aan gemeenschapsontwikkeling, sociale initiatieven en publieke dienst in de Dominicaanse Republiek. Hij verkoos praktische actie boven verklaringen, en de trage opeenstapeling van kleine, weloverwogen verbeteringen boven de beloften van grote abstracties.",
                "Hij geloofde dat een project pas bestaat wanneer het de ontmoeting met de werkelijkheid overleeft — wanneer de gemeenschap het beleeft, aanpast en verderdraagt. Elke methode die hij bouwde, elke les die hij gaf, keerde terug naar die eenvoudige toets.",
                "Zijn filosofie evolueerde zoals het land evolueerde, maar het middelpunt bewoog nooit: een project is de manier waarop een visie de grond raakt.",
                "Life is a Project bewaart die filosofie niet louter. Het ontwikkelt, verbreedt en past haar aan een veranderende wereld aan — in nieuwe talen, nieuwe instrumenten en nieuwe praktijkgebieden.",
            ],
            fr: [
                "Sa vie fut consacrée au développement communautaire, aux initiatives sociales et au service public en République dominicaine. Il préférait l’action pratique aux déclarations, et l’accumulation lente de petites améliorations délibérées aux promesses des grandes abstractions.",
                "Il croyait qu’un projet n’existe que lorsqu’il survit à sa rencontre avec la réalité — quand la communauté le vit, l’ajuste et le porte plus loin. Chaque méthode qu’il a bâtie, chaque leçon qu’il a transmise, revenait à cette épreuve simple.",
                "Sa philosophie a évolué comme le pays a évolué, mais son centre n’a jamais bougé : un projet, c’est la manière dont une vision touche le sol.",
                "Life is a Project ne se contente pas de préserver cette philosophie. Il la développe, l’élargit et l’adapte à un monde qui change — en de nouvelles langues, de nouveaux instruments et de nouveaux champs de pratique.",
            ],
        },
        originQuote: {
            en: "Life is a Project in constant construction and evolution. It is shaped by everything we experience throughout our lifetime — our work, experiences and sacrifices — as we shape it, adjust it and bring it to life according to our vision. A vision that grows larger through the projects we build.",
            es: "La vida es un proyecto en construcción y evolución constantes. La modelan todas las experiencias de nuestra existencia — el trabajo, las vivencias y los sacrificios — mientras la construimos, la ajustamos y la traemos a la vida según nuestra visión. Una visión que crece con los proyectos que levantamos.",
            nl: "Het leven is een project in voortdurende opbouw en evolutie. Het krijgt vorm door alles wat we in ons leven meemaken — ons werk, onze ervaringen en onze offers — terwijl we het vormgeven, bijstellen en tot leven brengen volgens onze visie. Een visie die groter wordt door de projecten die we bouwen.",
            fr: "La vie est un projet en construction et en évolution constantes. Elle est façonnée par tout ce que nous traversons — le travail, les expériences et les sacrifices — tandis que nous la formons, l’ajustons et la portons à la vie selon notre vision. Une vision qui grandit à travers les projets que nous bâtissons.",
        },
        originBy: {
            en: "— Pepe Castro",
            es: "— Pepe Castro",
            nl: "— Pepe Castro",
            fr: "— Pepe Castro",
        },
    },

    /* ---------- Philosophy ---------- */
    philosophy: {
        overline: {
            en: "Philosophy",
            es: "Filosofía",
            nl: "Filosofie",
            fr: "Philosophie",
        },
        title: {
            en: "Life is a project in constant construction and evolution.",
            es: "La vida es un proyecto en construcción y evolución constantes.",
            nl: "Het leven is een project in voortdurende opbouw en evolutie.",
            fr: "La vie est un projet en construction et en évolution constantes.",
        },
        lede: {
            en: "Practical on the surface. Philosophical underneath. The intellectual backbone of Life is a Project.",
            es: "Práctica en la superficie. Filosófica en el fondo. La espina intelectual de Life is a Project.",
            nl: "Praktisch aan de oppervlakte. Filosofisch daaronder. De intellectuele ruggengraat van Life is a Project.",
            fr: "Pratique en surface. Philosophique en profondeur. La colonne vertébrale intellectuelle de Life is a Project.",
        },
        sections: {
            en: [
                { k: "Vision",       t: "Vision gives direction.",           d: "A project without a vision drifts. Vision is the light that steadies the hand while the work is done." },
                { k: "Intention",    t: "Intention is the beginning.",       d: "Every project begins as a deliberate choice — a decision to shape something rather than watch it happen." },
                { k: "Reality",      t: "A project must meet reality.",      d: "Ideas that never leave the desk are not projects. Reality is the test that separates thought from action." },
                { k: "Construction", t: "Life is built, not received.",      d: "We inherit conditions; we build a life. Every project is a small act of construction against the drift of circumstance." },
                { k: "Experience",   t: "Experience reshapes the project.",  d: "What we live changes what we believe. Every project revises the one who builds it." },
                { k: "Work",         t: "Work is the currency of change.",   d: "Careful, patient, unglamorous work is what turns intention into structure." },
                { k: "Sacrifice",    t: "Something must be given up.",       d: "A serious project asks something of us. Sacrifice is not loss — it is investment in what matters more." },
                { k: "Action",       t: "Thought becomes visible in action.",d: "Action is the moment a project becomes real for someone other than its author." },
                { k: "Projects",     t: "Projects are the form of a vision.",d: "A vision without a project is a wish. A project without a vision is a task. Both matter; neither is enough alone." },
                { k: "Evolution",    t: "The project evolves with us.",      d: "Nothing serious is finished on the day it is finished. A living project is one that continues to learn." },
                { k: "Lighthouse",   t: "The lighthouse is not the destination.", d: "It is the light that helps us navigate toward the future we are trying to build." },
            ],
            es: [
                { k: "Visión",       t: "La visión da dirección.",           d: "Un proyecto sin visión se dispersa. La visión es la luz que sostiene la mano mientras se trabaja." },
                { k: "Intención",    t: "La intención es el comienzo.",      d: "Todo proyecto empieza con una decisión deliberada — la de dar forma a algo en vez de dejar que ocurra." },
                { k: "Realidad",     t: "El proyecto debe encontrarse con la realidad.", d: "Las ideas que no salen del escritorio no son proyectos. La realidad es la prueba que separa el pensamiento de la acción." },
                { k: "Construcción", t: "La vida se construye, no se recibe.",d: "Heredamos condiciones; construimos una vida. Cada proyecto es un pequeño acto de construcción frente a la deriva." },
                { k: "Experiencia",  t: "La experiencia rehace el proyecto.", d: "Lo que vivimos cambia lo que creemos. Cada proyecto revisa a quien lo construye." },
                { k: "Trabajo",      t: "El trabajo es la moneda del cambio.",d: "El trabajo cuidadoso, paciente y sin brillo es el que convierte la intención en estructura." },
                { k: "Sacrificio",   t: "Algo hay que dejar.",               d: "Un proyecto serio nos pide algo. El sacrificio no es pérdida — es inversión en lo que importa más." },
                { k: "Acción",       t: "El pensamiento se ve en la acción.",d: "La acción es el momento en que un proyecto se vuelve real para alguien distinto a su autor." },
                { k: "Proyectos",    t: "Los proyectos son la forma de una visión.", d: "Una visión sin proyecto es un deseo. Un proyecto sin visión es una tarea. Los dos importan; ninguno basta solo." },
                { k: "Evolución",    t: "El proyecto evoluciona con nosotros.", d: "Nada serio termina el día en que termina. Un proyecto vivo es el que sigue aprendiendo." },
                { k: "Faro",         t: "El faro no es el destino.",         d: "Es la luz que nos ayuda a navegar hacia el futuro que intentamos construir." },
            ],
            nl: [
                { k: "Visie",         t: "Visie geeft richting.",             d: "Een project zonder visie dwaalt af. Visie is het licht dat de hand vaststaat terwijl het werk gebeurt." },
                { k: "Intentie",      t: "Intentie is het begin.",            d: "Elk project begint met een bewuste keuze — de beslissing iets vorm te geven in plaats van het te laten gebeuren." },
                { k: "Werkelijkheid", t: "Een project moet de werkelijkheid ontmoeten.", d: "Ideeën die het bureau nooit verlaten, zijn geen projecten. De werkelijkheid is de test." },
                { k: "Opbouw",        t: "Het leven wordt gebouwd, niet ontvangen.", d: "We erven omstandigheden; we bouwen een leven. Elk project is een kleine daad van opbouw tegen de drift van omstandigheden." },
                { k: "Ervaring",      t: "Ervaring hervormt het project.",    d: "Wat we meemaken verandert wat we geloven. Elk project herziet degene die het bouwt." },
                { k: "Werk",          t: "Werk is de munt van verandering.",  d: "Zorgvuldig, geduldig en onopvallend werk zet intentie om in structuur." },
                { k: "Offer",         t: "Er moet iets worden opgegeven.",    d: "Een serieus project vraagt iets van ons. Een offer is geen verlies — het is investering in wat meer telt." },
                { k: "Actie",         t: "Denken wordt zichtbaar in actie.",  d: "Actie is het moment waarop een project echt wordt voor iemand anders dan de auteur." },
                { k: "Projecten",     t: "Projecten zijn de vorm van een visie.", d: "Een visie zonder project is een wens. Een project zonder visie is een taak. Beide tellen; geen van beide volstaat alleen." },
                { k: "Evolutie",      t: "Het project evolueert met ons mee.", d: "Niets serieus is af op de dag dat het af is. Een levend project blijft leren." },
                { k: "Vuurtoren",     t: "De vuurtoren is niet de bestemming.", d: "Het is het licht dat ons helpt navigeren naar de toekomst die we proberen te bouwen." },
            ],
            fr: [
                { k: "Vision",        t: "La vision donne la direction.",     d: "Un projet sans vision dérive. La vision est la lumière qui tient la main pendant que le travail se fait." },
                { k: "Intention",     t: "L’intention est le commencement.",  d: "Tout projet commence par un choix délibéré — celui de donner forme à quelque chose plutôt que de le laisser arriver." },
                { k: "Réalité",       t: "Un projet doit rencontrer la réalité.", d: "Les idées qui ne quittent jamais le bureau ne sont pas des projets. La réalité est l’épreuve." },
                { k: "Construction",  t: "La vie se construit, elle ne se reçoit pas.", d: "Nous héritons de conditions ; nous bâtissons une vie. Chaque projet est un petit acte de construction." },
                { k: "Expérience",    t: "L’expérience refait le projet.",    d: "Ce que nous vivons change ce que nous croyons. Chaque projet revoit celui qui le bâtit." },
                { k: "Travail",       t: "Le travail est la monnaie du changement.", d: "Un travail soigné, patient et discret transforme l’intention en structure." },
                { k: "Sacrifice",     t: "Il faut donner quelque chose.",     d: "Un projet sérieux exige quelque chose de nous. Le sacrifice n’est pas une perte — c’est un investissement." },
                { k: "Action",        t: "La pensée devient visible dans l’action.", d: "L’action est le moment où un projet devient réel pour quelqu’un d’autre que son auteur." },
                { k: "Projets",       t: "Les projets sont la forme d’une vision.", d: "Une vision sans projet est un souhait. Un projet sans vision est une tâche. Aucun des deux ne suffit seul." },
                { k: "Évolution",     t: "Le projet évolue avec nous.",        d: "Rien de sérieux n’est achevé le jour où on le termine. Un projet vivant continue d’apprendre." },
                { k: "Phare",         t: "Le phare n’est pas la destination.", d: "C’est la lumière qui nous aide à naviguer vers l’avenir que nous cherchons à bâtir." },
            ],
        },
    },

    /* ---------- Lighthouse ---------- */
    lighthouse: {
        overline: {
            en: "The Lighthouse",
            es: "El Faro",
            nl: "De Vuurtoren",
            fr: "Le Phare",
        },
        title: {
            en: "A fixed point in a changing world.",
            es: "Un punto fijo en un mundo que cambia.",
            nl: "Een vast punt in een veranderende wereld.",
            fr: "Un point fixe dans un monde qui change.",
        },
        lede: {
            en: "The lighthouse is the symbol of Life is a Project. It stands for vision, direction, continuity and guidance — the light that projects our ideas forward, and that helps us navigate toward the future we are trying to build.",
            es: "El faro es el símbolo de Life is a Project. Representa la visión, la dirección, la continuidad y la guía — la luz que proyecta nuestras ideas hacia adelante, y que nos ayuda a navegar hacia el futuro que intentamos construir.",
            nl: "De vuurtoren is het symbool van Life is a Project. Hij staat voor visie, richting, continuïteit en gids — het licht dat onze ideeën vooruit werpt en ons helpt navigeren naar de toekomst die we proberen te bouwen.",
            fr: "Le phare est le symbole de Life is a Project. Il incarne la vision, la direction, la continuité et la guidance — la lumière qui projette nos idées vers l’avant et qui nous aide à naviguer vers l’avenir que nous cherchons à bâtir.",
        },
        pillars: {
            en: [
                { k: "Vision",       d: "The light we choose to project into the future." },
                { k: "Direction",    d: "The steady axis by which we orient our work." },
                { k: "Continuity",   d: "A signal that survives our own hours at the helm." },
                { k: "Guidance",     d: "A source of orientation, not a place of arrival." },
            ],
            es: [
                { k: "Visión",       d: "La luz que elegimos proyectar hacia el futuro." },
                { k: "Dirección",    d: "El eje firme por el que orientamos el trabajo." },
                { k: "Continuidad",  d: "Una señal que sobrevive a nuestras horas al timón." },
                { k: "Guía",         d: "Una fuente de orientación, no un lugar de llegada." },
            ],
            nl: [
                { k: "Visie",        d: "Het licht dat we in de toekomst projecteren." },
                { k: "Richting",     d: "De vaste as waarlangs we het werk oriënteren." },
                { k: "Continuïteit", d: "Een signaal dat onze uren aan het roer overleeft." },
                { k: "Gids",         d: "Een bron van oriëntatie, geen plaats van aankomst." },
            ],
            fr: [
                { k: "Vision",       d: "La lumière que nous choisissons de projeter dans l’avenir." },
                { k: "Direction",    d: "L’axe stable qui oriente notre travail." },
                { k: "Continuité",   d: "Un signal qui survit à nos heures à la barre." },
                { k: "Guidance",     d: "Une source d’orientation, non un lieu d’arrivée." },
            ],
        },
        closing: {
            en: "The lighthouse is not the destination. It is what makes the destination possible.",
            es: "El faro no es el destino. Es lo que hace posible el destino.",
            nl: "De vuurtoren is niet de bestemming. Hij maakt de bestemming mogelijk.",
            fr: "Le phare n’est pas la destination. Il est ce qui rend la destination possible.",
        },
    },

    /* ---------- Contact ---------- */
    contact: {
        overline: {
            en: "Contact",
            es: "Contacto",
            nl: "Contact",
            fr: "Contact",
        },
        title: {
            en: "Write to Life is a Project.",
            es: "Escríbenos a Life is a Project.",
            nl: "Schrijf naar Life is a Project.",
            fr: "Écrivez à Life is a Project.",
        },
        lede: {
            en: "For thoughtful correspondence — collaborations, questions, invitations, or a note about the work.",
            es: "Para correspondencia reflexiva — colaboraciones, preguntas, invitaciones o una nota sobre el trabajo.",
            nl: "Voor doordachte correspondentie — samenwerkingen, vragen, uitnodigingen of een reactie op het werk.",
            fr: "Pour une correspondance réfléchie — collaborations, questions, invitations ou un mot sur le travail.",
        },
        name:    { en: "Your name",        es: "Su nombre",        nl: "Uw naam",         fr: "Votre nom" },
        email:   { en: "Your email",       es: "Su correo",        nl: "Uw e-mail",       fr: "Votre courriel" },
        org:     { en: "Organisation (optional)", es: "Organización (opcional)", nl: "Organisatie (optioneel)", fr: "Organisation (optionnel)" },
        message: { en: "Your message",     es: "Su mensaje",       nl: "Uw bericht",      fr: "Votre message" },
        submit:  { en: "Send",             es: "Enviar",           nl: "Verzenden",       fr: "Envoyer" },
        sending: { en: "Sending…",         es: "Enviando…",        nl: "Verzenden…",      fr: "Envoi…" },
        success: { en: "Thank you. Your message has been received.", es: "Gracias. Su mensaje ha sido recibido.", nl: "Dank u. Uw bericht is ontvangen.", fr: "Merci. Votre message a bien été reçu." },
        error:   { en: "Something went wrong. Please try again shortly.", es: "Algo salió mal. Inténtelo de nuevo en breve.", nl: "Er ging iets mis. Probeer het zo opnieuw.", fr: "Une erreur est survenue. Merci de réessayer sous peu." },
        note:    { en: "We answer in the language you prefer.", es: "Respondemos en el idioma que prefiera.", nl: "Wij antwoorden in de taal die u verkiest.", fr: "Nous répondons dans la langue que vous préférez." },
    },

    /* ---------- Footer ---------- */
    footer: {
        explore: { en: "Explore", es: "Explorar",  nl: "Ontdek",  fr: "Explorer" },
        aboutH:  { en: "About",   es: "Sobre",     nl: "Over",    fr: "À propos" },
        connect: { en: "Connect", es: "Contacto",  nl: "Contact", fr: "Contact" },
        rights:  {
            en: "© 2026 Life is a Project. All work in progress.",
            es: "© 2026 Life is a Project. Obra en construcción.",
            nl: "© 2026 Life is a Project. Werk in uitvoering.",
            fr: "© 2026 Life is a Project. Travail en cours.",
        },
    },
};

// Small helper: pick a translation from a {en,es,nl,fr} dict with EN fallback.
export const pick3 = (dict, lang) => (dict && (dict[lang] || dict.en)) || "";
